import { useEffect, useState } from "react";
import { initialize } from "openapi/core/OpenAPI";
import { load } from "config/env";
import { App } from "../App";
import { Box } from "@mui/material";

export const LoadConfigRender = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    load().then(() => {
      initialize();
      setHasLoaded(true);
    });
  });

  if (!hasLoaded) {
    return <Box data-testid="not-loaded" />;
  }

  return <App />;
};
